import { Component, Input, ChangeDetectionStrategy, OnInit, numberAttribute } from '@angular/core';
import { NumberService } from '../../services/number/number.service';

/**
 * Image Placeholder Component
 *
 * Creates place holder for img tags with same height/width
 * as img before image load is complete.
 * Helps to keep div height while the image is loading.
 * Uses aspectRatio (width:height) to calculate height percantage
 *
 * @example
 * <td-wb-image-placeholder aspectRatio="16:9">
 *  <img src="someimage.jpg">
 * </td-wb-image-placeholder>
 *
 */
@Component({
  selector: 'td-wb-image-placeholder',
  templateUrl: './image-placeholder.component.html',
  styleUrls: ['./image-placeholder.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImagePlaceholderComponent implements OnInit {
  @Input() aspectRatio: string = '1:1';

  heightPercentage: number = 100;

  ngOnInit(): void {
    if (this.aspectRatio !== undefined) {
      const aspectRatioValues =  this.aspectRatio.split(':');
      if (aspectRatioValues.length === 2) {
        const width  = numberAttribute(aspectRatioValues[0], 1);
        const height = numberAttribute(aspectRatioValues[1], 1);
        if (width !== 0) {
          this.heightPercentage = (height / width) * 100;
          this.heightPercentage = NumberService.round(this.heightPercentage, 4);
        }
      }
    }
  }
}
